import * as React from "react"
import { Box } from "@mui/material"

import PricingCandlestickTooltip from "./Tooltip"


const minHeight = 8

export default function PricingCandlestickChartBlock({ discounts, color, rowHeight, minDiscount, maxDiscount, groupedID, externalSeller }) {

    return <Box sx={{ width: 1, height: 1, pl: 2, position: 'relative' }}>
        { discounts.map(({ discount, numSkus, ...props }, idx) => {
            const calculateLeft = ((discount - minDiscount) / ( maxDiscount - minDiscount)) * 100
            const heightData = numSkus + minHeight
            const calculateHeight = heightData < rowHeight ? heightData : rowHeight

            const bottom = `3px`
            const left = `${calculateLeft < .5 ? .5 : calculateLeft}%`
            const height = `${calculateHeight}px`
            const width = 6

            return <PricingCandlestickTooltip
                key={idx}
                bottom={bottom}
                left={left}
                width={width}
                height={height}
                discount={discount}
                numSkus={numSkus}
                groupedID={groupedID}
                externalSeller={externalSeller}
            >
                <Box sx={{
                    display: 'inline',
                    position: 'absolute',
                    bottom, left, width, height,
                    backgroundColor: color,
                    borderRadius: 15
                }} />
            </PricingCandlestickTooltip>
        }) }
    </Box>
}